import { render } from "./MergeColour.vue?vue&type=template&id=0bcef03d"
import script from "./MergeColour.vue?vue&type=script&lang=js"
export * from "./MergeColour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__